"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * @author Jan Prokop
 */


var WindowChangeDTOConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(WindowChangeDTOConverter, _DataObjectConverter_);

  function WindowChangeDTOConverter() {
    _classCallCheck(this, WindowChangeDTOConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(WindowChangeDTOConverter).apply(this, arguments));
  }

  return WindowChangeDTOConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.WindowChangeDTOConverter = WindowChangeDTOConverter;